import { render, staticRenderFns } from "./ResultHeader.vue?vue&type=template&id=c23d326e&"
import script from "./ResultHeader.vue?vue&type=script&lang=js&"
export * from "./ResultHeader.vue?vue&type=script&lang=js&"
import style0 from "./ResultHeader.vue?vue&type=style&index=0&id=c23d326e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports